'use strict';
const userCodeModules = new Map(); //eslint-disable-line no-undef
const elementoryArgumentsHandler = require('./elementoryArgumentsHandler');

const SCRIPT_ERROR_MESSAGE = 'There was an error in your script';

function _getEmptyModule() {
  return {};
}

function _filterExistScripts(scripts) {
  return scripts.filter(script => !userCodeModules.has(script.url));
}

function _setRouterData(routerData) {
  if (routerData) {
    self.routerData = routerData;
  }
}

/*eslint-disable no-console*/
function fetchUserCode(wixCodeScripts, importScriptFunc, {routerData} = {}) {
  _setRouterData(routerData); // not sure this code relevant

  const scriptsToFetch = _filterExistScripts(wixCodeScripts);

  scriptsToFetch.forEach(script => {
    try {
      const moduleFunc = importScriptFunc(script.url, script.displayName);
      userCodeModules.set(script.url, moduleFunc);
    } catch (e) {
      console.error(SCRIPT_ERROR_MESSAGE);
      console.error(e);
      userCodeModules.set(script.url, _getEmptyModule);
    }
  });
}

function fetchUserCodeAsync(wixCodeScripts, loadAmdFunc, {routerData} = {}) {
  _setRouterData(routerData); // not sure this code relevant

  const scriptsToFetch = _filterExistScripts(wixCodeScripts);

  return scriptsToFetch.reduce((promise, script) => promise.then(acc =>
    loadAmdFunc(script.url)
      .then(userCode => acc.set(script.url, userCode)))
  , Promise.resolve(userCodeModules));
}

function startUserCode(wixCodeScripts, {elementoryArguments, routerData} = {}) {
  _setRouterData(routerData);

  if (elementoryArguments) {
    elementoryArgumentsHandler.setElementoryArguments(elementoryArguments);
  }

  const modules = wixCodeScripts.map(({script, $w, storage}) => {
    if (console.info) {
      console.info(`Loading the code for the ${script.displayName}. To debug this code, open ${script.scriptName} in Developer Tools.`);
    }

    let module = {};
    if (!userCodeModules.has(script.url)) {
      throw new Error(`the script ${script.url} was not loaded using the "load_user_code" event`);
    }

    // I think this code is an old leftover.
    // wix-window.getRouterData uses self.routerData.
    // I couldn't find any relevant usage of it in wix-private.
    // initAppForPage passes this parameter - first arguments
    // for now we just doing copy-paste
    self.routerReturnedData = script.routerData;
    self.$w = $w;
    self['wix-storage'] = storage;

    try {
      const moduleFunc = userCodeModules.get(script.url);
      module = moduleFunc && moduleFunc();

    } catch (e) {
      console.error(SCRIPT_ERROR_MESSAGE);
      console.error(e);
    }

    delete self.routerReturnedData;
    delete self.$w;
    delete self['wix-storage'];

    return module;
  });

  return modules.reduce((r, c) => Object.assign(r, c), {});
}

module.exports = {
  fetchUserCodeAsync,
  fetchUserCode,
  startUserCode
};
